const video = () => {
  Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get() {
      return !!(
        this.currentTime > 0 &&
        !this.paused &&
        !this.ended &&
        this.readyState > 2
      );
    },
  });

  const videos = document.querySelectorAll('.c-video--fullheight');
  if (videos.length) {
    videos.forEach(item => {
      const videoElementDesktop = item.querySelector(
        '.c-video__video--desktop',
      );
      const imageElementDesktop = item.querySelector(
        '.c-video__image--desktop',
      );

      if (videoElementDesktop && imageElementDesktop) {
        if (!videoElementDesktop.playing) {
          videoElementDesktop.classList.add('low-powermode');
          imageElementDesktop.classList.remove('low-powermode');
        }

        document.querySelector('body').addEventListener('touchstart', () => {
          if (!videoElementDesktop.playing) {
            videoElementDesktop.play();
          }
        });

        videoElementDesktop.addEventListener('play', () => {
          videoElementDesktop.classList.remove('low-powermode');
          imageElementDesktop.classList.add('low-powermode');
        });
      }

      const videoElementMobile = item.querySelector('.c-video__video--mobile');
      const imageElementMobile = item.querySelector('.c-video__image--mobile');

      if (videoElementMobile && imageElementMobile) {
        if (!videoElementMobile.playing) {
          videoElementMobile.classList.add('low-powermode');
          imageElementMobile.classList.remove('low-powermode');
        }

        document.querySelector('body').addEventListener('touchstart', () => {
          if (!videoElementMobile.playing) {
            videoElementMobile.play();
          }
        });

        videoElementMobile.addEventListener('play', () => {
          videoElementMobile.classList.remove('low-powermode');
          imageElementMobile.classList.add('low-powermode');
        });
      }
    });
  }
};

video();
